import Creators from "./actions";
import ReusableCachePageService from "../ReusableCachePageService";

const fetchCachePages = (overrides = {}) => async (dispatch, getState) => {
  dispatch(Creators.fetchCachePagesBegin());

  const state = getState();
  const slice = state.cachePages || {};
  const filters = slice.filters || {};

  const approvedValue =
    Object.prototype.hasOwnProperty.call(overrides, "approved")
      ? overrides.approved
      : Object.prototype.hasOwnProperty.call(filters, "approved")
      ? filters.approved
      : null;

  const payload = {
    ...filters,
    ...overrides,
    results_per_page: overrides.results_per_page ?? slice.results_per_page ?? 25,
    page_num: overrides.page_num ?? slice.page_num ?? 1,
  };

  if (approvedValue === true || approvedValue === false) {
    payload.approved = approvedValue;
  } else {
    delete payload.approved;
  }

  payload.filter_used_count_min =
    payload.filter_used_count_min === "" ||
    payload.filter_used_count_min === undefined
      ? null
      : Number(payload.filter_used_count_min);

  payload.filter_used_count_max =
    payload.filter_used_count_max === "" ||
    payload.filter_used_count_max === undefined
      ? null
      : Number(payload.filter_used_count_max);

  payload.filter_created_from = payload.filter_created_from || null;
  payload.filter_created_to = payload.filter_created_to || null;
  payload.filter_published_from = payload.filter_published_from || null;
  payload.filter_published_to = payload.filter_published_to || null;
  payload.filter_last_used_from = payload.filter_last_used_from || null;
  payload.filter_last_used_to = payload.filter_last_used_to || null;

  if (payload.filter_used_count_min === null || Number.isNaN(payload.filter_used_count_min)) {
    delete payload.filter_used_count_min;
  }

  if (payload.filter_used_count_max === null || Number.isNaN(payload.filter_used_count_max)) {
    delete payload.filter_used_count_max;
  }

  // remove empty date filters
  if (!payload.filter_created_from) delete payload.filter_created_from;
  if (!payload.filter_created_to) delete payload.filter_created_to;
  if (!payload.filter_published_from) delete payload.filter_published_from;
  if (!payload.filter_published_to) delete payload.filter_published_to;
  if (!payload.filter_last_used_from) delete payload.filter_last_used_from;
  if (!payload.filter_last_used_to) delete payload.filter_last_used_to;

  console.log("APPROVED VALUE:", approvedValue);
  console.log("CACHE PAGE PAYLOAD:", payload);

  try {
    const response = await ReusableCachePageService.getReusableCachePages(payload);
    dispatch(Creators.fetchCachePagesSuccess(response?.data || {}));
  } catch (error) {
    dispatch(Creators.fetchCachePagesError(error));
  }
};

const setCachePagesFilters = (filters) => (dispatch) => {
  dispatch(Creators.setCachePagesFilters(filters));
};

const bulkUpdateCachePageApproval =
  ({ ids = [], approved }) =>
  async (dispatch) => {
    dispatch(Creators.updateCachePagesBegin());

    try {
      const cachepagelist = (ids || []).map((id) => ({
        cachepageid: Number(id),
        action: "update_cp_approval",
        approved: !!approved,
      }));

      const response = await ReusableCachePageService.updateReusableCachePages({
        cachepagelist,
      });

      dispatch(Creators.updateCachePagesSuccess(response?.data || {}));
      return response;
    } catch (error) {
      dispatch(Creators.updateCachePagesError(error));
      throw error;
    }
  };

export default {
  fetchCachePages,
  setCachePagesFilters,
  bulkUpdateCachePageApproval,
};